import { required, requiredNumber } from '@constants/Rules'

// Regras de validação que tornam um campo obrigatório.
const REQUIRED_RULES = new Set([required, requiredNumber])

/**
 * Detecta se um campo é obrigatório a partir dos sinais disponíveis:
 * - `rules` contém a regra `required`/`requiredNumber` (padrão do projeto)
 * - a prop `required` é true (override explícito)
 * - o `label` legado termina em "*" (ex: 'Nome*')
 *
 * @param {Object} params
 * @param {Array}  [params.rules]    Array de regras passado ao input
 * @param {Boolean}[params.required] Override explícito
 * @param {String} [params.label]    Label externo (pode ter "*" embutido legado)
 * @returns {Boolean}
 */
export const isFieldRequired = ({ rules, required: requiredProp, label } = {}) => {
  const byRules =
    Array.isArray(rules) && rules.some((rule) => REQUIRED_RULES.has(rule))
  const byLabel = labelHasRequiredMark(label)
  return byRules || !!requiredProp || byLabel
}

/**
 * Verifica se o label termina com "*" (marca de obrigatório legada).
 * @param {String} label
 * @returns {Boolean}
 */
export const labelHasRequiredMark = (label) =>
  (label || '').trim().endsWith('*')

/**
 * Remove o "*" final (e espaços) de um label legado, para o asterisco virar um
 * elemento próprio (vermelho) sem ficar DOIS asteriscos juntos. Aceita "Nome*",
 * "Nome *", "Nome**" etc.
 * @param {String} label
 * @returns {String}
 */
export const stripRequiredMark = (label) => {
  if (!label) return ''
  // Sem "*" final → não mexe (preserva o label como está, inclusive espaços).
  if (!labelHasRequiredMark(label)) return label
  // Remove os "*" finais + os espaços ao redor sem regex com backtracking
  // (evita o hotspot de ReDoS): trim no fim, tira os asteriscos, trim de novo.
  let result = label.trimEnd()
  while (result.endsWith('*')) result = result.slice(0, -1)
  return result.trimEnd()
}
